import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	createProject: {
		id: 'project-create-form.ui.create-project',
		defaultMessage: 'Create project',
		description: '',
	},
	create: {
		id: 'project-create-form.ui.create',
		defaultMessage: 'Create',
		description: '',
	},
	createPageTitle: {
		id: 'project-create-form.ui.create-page-title',
		defaultMessage: 'Create Project - Jira',
		description: 'Page title for Create Project screen',
	},
	back: {
		id: 'project-create-form.ui.back',
		defaultMessage: 'Back',
		description: 'Back button label',
	},
	next: {
		id: 'project-create-form.ui.next',
		defaultMessage: 'Next',
		description: 'Next button label',
	},
	close: {
		id: 'project-create-form.ui.close',
		defaultMessage: 'Close',
		description: 'Close button label and text',
	},
	template: {
		id: 'project-create-form.ui.template',
		defaultMessage: 'Template',
		description: 'Heading below which the current selected template is displayed',
	},
	defaultLanguage: {
		id: 'project-create-form.ui.default-language',
		defaultMessage: 'Default language',
		description: 'Option in JSM to choose default language for the project',
	},
	changeTemplate: {
		id: 'project-create-form.ui.change-template',
		defaultMessage: 'Change template',
		description:
			'Text on a button that indicates you can go back and change the project template you wish to create if you picked the wrong one',
	},
	advanced: {
		id: 'project-create-form.ui.advanced',
		defaultMessage: 'Advanced',
		description: '',
	},
	whatIsInThis: {
		id: 'project-create-form.ui.what-is-in-this',
		defaultMessage: "What's in this?",
		description:
			'Text in a button adjacent to the change template button underneath the currently selected template in the project create form. Pressing this will open a dialog describing what is included in the currently selected template',
	},
	tellMeMore: {
		id: 'project-create-form.ui.tell-me-more',
		defaultMessage: 'Tell me more',
		description:
			'Text in a button adjacent to the change template button underneath the currently selected template in the project create form. Pressing this will open a dialog describing what is included in the currently selected template',
	},
	// new project create screen
	backToProjectTemplate: {
		id: 'project-create-form.ui.back-to-project-template',
		defaultMessage: 'Back to project templates',
		description: 'Text in a button for going back to the template selector',
	},
	backToChooseAProjectType: {
		id: 'project-create-form.ui.back-to-choose-a-project-type',
		defaultMessage: 'Back to project types',
		description: 'Text in a button for going back to project types comparison screen',
	},
	createProjectTitle: {
		id: 'project-create-form.ui.create-project-title',
		defaultMessage: 'Add project details',
		description: 'Title of project create screen',
	},
	createProjectPageTitle: {
		id: 'project-create-form.ui.create-project-page-title',
		defaultMessage: 'Add project details - Jira',
		description: 'Title of project create screen',
	},
	createProjectDescription: {
		id: 'project-create-form.ui.create-project-description',
		defaultMessage:
			"Explore what's possible when you collaborate with your team. Edit project details anytime in project settings.",
		description: 'Description of project create screen',
	},
	createProjectDescriptionJsm: {
		id: 'project-create-form.ui.create-project-description-jsm',
		defaultMessage:
			'Add your project’s details and confirm your template to create your new project in seconds. Edit project details anytime in project settings.',
		description: 'Description of project create screen',
	},
	createCrossTeamTemplateProjectDescription: {
		id: 'project-create-form.ui.create-cross-team-template-project-description',
		defaultMessage:
			'This template creates a project to store your high-level goals and uses it as a basis of a plan.',
		description: 'Description of project create screen',
	},
	createCrossTeamPlanningTemplateProjectDescription: {
		id: 'project-create-form.ui.create-cross-team-planning-template-project-description',
		defaultMessage:
			'This template creates a project, a plan, and two new teams with their own scrum board.',
		description: 'Description of project create screen',
	},
	cancel: {
		id: 'project-create-form.ui.cancel',
		defaultMessage: 'Cancel',
		description: 'Cancel button label and text',
	},
	createProjectText: {
		id: 'project-create-form.ui.create-project-text',
		defaultMessage: 'Create project',
		description: 'Label of create project button',
	},
	createProjectAndPlanText: {
		id: 'project-create-form.ui.create-project-and-plan-text',
		defaultMessage: 'Create a project and a plan',
		description: 'Title for creating top level planning template',
	},
	recommendationLozenge: {
		id: 'project-create-form.ui.recommendation-lozenge',
		defaultMessage: 'Recommended',
		description: 'Lozenge label shown when system selects project template and type for user',
	},
	/* eslint-disable jira/i18n/id-named-by-package */
	PROJECT_SHARED_CONFIG_NAME: {
		id: 'project-create.create-form.project-shared-config-name',
		defaultMessage: 'Shared with an existing project',
		description: 'Project template type to share an existing project template',
	},
	/* eslint-disable jira/i18n/id-named-by-package */
	PROJECT_SHARED_CONFIG_DESCRIPTION: {
		id: 'project-create.create-form.project-shared-config-description',
		defaultMessage: 'Create a project with pre-existing shared configuration',
		description: '',
	},
	createProjectFailureTitleNonFinal: {
		id: 'project-create-common.common.flags.create-project-failure-title',
		defaultMessage: 'Project not created',
		description: 'Title for the flag that appears when a project creation fails',
	},
	createProjectFailureDescriptionNonFinal: {
		id: 'project-create-common.common.flags.create-project-failure-description',
		defaultMessage: "For some reason the magic didn't happen. Click Create to try again.",
		description: 'Description for the flag that appears when a project creation fails',
	},
	backToProjectTemplateGalaxia: {
		id: 'project-create-form.ui.back-to-project-template-galaxia',
		defaultMessage: 'Back to templates',
		description: 'Text in a button for going back to the template selector',
	},
	createProjectTitleGalaxia: {
		id: 'project-create-form.ui.create-project-title-galaxia',
		defaultMessage: 'Add space details',
		description: 'Title of project create screen',
	},
	createProjectPageTitleGalaxia: {
		id: 'project-create-form.ui.create-project-page-title-galaxia',
		defaultMessage: 'Add space details - Jira',
		description: 'Title of project create screen',
	},
	createProjectTextGalaxia: {
		id: 'project-create-form.ui.create-project-text-galaxia',
		defaultMessage: 'Create space',
		description: 'Label of create project button',
	},
	createProjectDescriptionGalaxia: {
		id: 'project-create-form.ui.create-project-description-galaxia',
		defaultMessage:
			"Explore what's possible when you collaborate with your team. Edit space details anytime in space settings.",
		description: 'Description of project create screen',
	},
	createProjectFailureTitleNonFinalGalaxia: {
		id: 'project-create-common.common.flags.create-project-failure-title-galaxia',
		defaultMessage: 'Space not created',
		description: 'Title for the flag that appears when a project creation fails',
	},
});
